import { useState } from "react";
import useMailSender from "../hooks/useMailSender.js";
import { useModal } from "../contexts/modalContext/modalContext.js";
import { useUser } from "../contexts/userContext/userContext.js";
import { useToasts } from "react-toast-notifications";
import { useMail } from "../contexts/mailContext/mailContext.js";
import { useContent } from "../contexts/contentContext/contentContext.js";
import ConfirmationModal from "../components/Reusable/ConfirmationModal/ConfirmationModal.js";
import NotEnoughSpaceModal from "../components/Reusable/SaveMail/NotEnoughSpaceModal.js";
import SaveMail from "../components/Reusable/SaveMail/SaveMail.js";

// IsSaved - In general if saved by smomeone
// IsSavedByUser - If the current logged in user saved mail
// IsSavedByOtherUser - if someone else (not current logged in user) saved the mail 

export const useSaveAction = () => {
  const { setModal, closeModal } = useModal();
  const { saveMailByCode, saveMailAsSubscriber, getMailMetaData } = useMail();

  const { isSubscribed, getUserData } = useUser();
  const { getTextByKey } = useContent();
  const [loading, setLoading] = useState(false);
  const { isMailSender } = useMailSender();
  const { addToast } = useToasts();

  const isSavedByCurrentUser =
    getMailMetaData().EmailOfEmbedOwner === getUserData().UserName
      ? getMailMetaData().IsSaved
      : getMailMetaData().IsSavedByUser;

  const saveActionFunc = async () => {
    if (isSubscribed() || isSavedByCurrentUser) {
      setLoading(true);
      const response = await saveMailAsSubscriber();
      if (response.status === "success") {
        addToast(
          getTextByKey(`${isSavedByCurrentUser ? "un" : ""}save-mail-success`),
          {
            appearance: isSavedByCurrentUser ? "info" : "success",
          }
        );
        setLoading(false);
      } else {
        if (response.data === "no-space") {
          setModal({ modal: NotEnoughSpaceModal });
        } else {
          addToast(getTextByKey(`please-contact-support`), {
            appearance: "warning",
          });
        }
        setLoading(false);
      }
      return response;
    } else {
      showSaveModal();
    }
  };

  const handleClick = () => {
    if (getMailMetaData().IsSavedByUser) {
      setModal({
        modal: ConfirmationModal,
        props: {
          confirmTitle: getTextByKey("confirm-unsave-mail-title"),
          confirmText: getTextByKey("confirm-unsave-mail-text"),
          yesButtonText: getTextByKey("confirm-unsave-mail-button-yes"),
          noButtonText: getTextByKey("confirm-unsave-mail-button-no"),
          confirmAction: () => saveActionFunc(),
        },
      });
    } else {
      saveActionFunc();
    }
  };

  const showSaveModal = () => {
    setModal({
      modal: SaveMail,
      modalSize: "full-modal",
      props: {
        isMailSender: isMailSender(),
        saveMailByCode,
        closeElement: closeModal,
      },
    });
  };

  return { handleClick, loading, isSavedByCurrentUser };
};
